export default __webpack_public_path__ + "static/media/2022_05_23 - Puma - 0421-2.35573e82.jpeg";